import { IControlOverrideOption } from './ControlFacet';
import { graft } from '../../utilities/Graft';

/**
 * @internal
 */
export function graftControlOption<T extends object>(): IControlOverrideOption<T> {
  return {
    merge: (previous: T | undefined, current: T | undefined): T | undefined => {
      return current && previous && graft({
        value: previous
      }, {
          value: current
        }).value || current || previous;
    }
  };
}
